"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PracticeContent = void 0;
const enums_1 = require("../../enums");
const ThinContentModel_1 = require("./ThinContentModel");
class PracticeContent extends ThinContentModel_1.ThinContentModel {
    constructor(type, id) {
        super(enums_1.ContentRepository.Practice, type);
        this.id = id;
    }
    static create(type, id) {
        return new PracticeContent(type, id);
    }
    serialize() {
        return `${this.serializeBase}${this.id}`;
    }
    static deserialize(serializedContent) {
        if (!serializedContent || !serializedContent.trim()) {
            throw new Error(serializedContent);
        }
        const fields = serializedContent.split(ThinContentModel_1.ThinContentModel.SerializeFieldSeparator);
        if (fields.length !== 3) {
            throw new Error(`${serializedContent} is invalid or missing required fields`);
        }
        const repository = fields[0];
        const type = fields[1];
        const id = fields[2];
        if (repository !== enums_1.ContentRepository.Practice) {
            throw new Error(`${serializedContent} does not have a valid Repository value`);
        }
        if (!(type in enums_1.ContentType)) {
            throw new Error(`${serializedContent} does not have a valid Type value`);
        }
        if (!id) {
            throw new Error(`${serializedContent} does not have a valid id value`);
        }
        return new PracticeContent(type, id);
    }
}
exports.PracticeContent = PracticeContent;
